module.exports = __webpack_public_path__ + "static/media/loader-animation.5ea37e79.svg";